
import { h } from 'vue'
import { RouterView } from 'vue-router'

export var ServiceRoutes = (navDataitems, callback) => {
  const specialMap = {
    '/service/project/progress_photo_video/progress_block_photo': 'ServiceBlockPhotoGallery',
    '/service/project/progress_photo_video/equipment_photo': 'ServiceEquipmentGallery',
    '/service/project/progress_photo_video/3d_rendering_images': 'ServiceRenderingGallery',
    '/service/project/progress_photo_video/hse_video': 'ServiceHseVideoGallery',
    '/service/project/progress_photo_video/project_progress_video': 'ServiceProjectVideoGallery',

  }

  let rRoutes = []

  navDataitems.forEach((p) => {
    let pRoute = {
      path: p.url,
      name: `${p.phaseName}_${p.phaseCode}`,
      component: RouterView,
      children: [],
    }

    if (!!p.children) p.children.forEach((g) => {
      
      let gRoute = {
        path: g.url,
        name: `${g.groupName}_${g.groupCode}`,
        component: RouterView,
        children: [],
      }

      if (!!g.children) g.children.forEach((t) => {

        if (specialMap[t.url]) {
          gRoute.children.push({
            path: t.url,
            name: `${t.itemName}_${t.itemCode}`,
            component: () => import(`@/views/service/${specialMap[t.url]}`),
            meta: { direction: t.direction, title: t.itemName }
          })
          // 기본 redirect 설정
          if (!gRoute.redirect) {
            gRoute.redirect = t.url
          }
          return
        }

        let tRoute = {
          path: t.url,
          name: `${t.itemName}_${t.itemCode}`,
          component: () => t.direction == 'CUSTOM' ? import(`@/views/custom/${t.customCompoment}`) : import(`@/views/service/${t.direction}`),
          meta: { title: t.itemName },
          children: [],
        }

        if (t.subItem == 'Y' && t.numChild > 0) {      
          if (!!t.children) t.children.forEach((s) => {
            let directionName = s.direction == 'CUSTOM' ? s.customCompoment : s.direction
            let sRoute = {
              path: s.url,
              name: `${s.subItemName}_${t.itemCode}_${s.subItemSn}`, //t.subItemName + '_' + t.itemCode + '_' + t.subItemSn,
              component: () => s.direction == 'CUSTOM' ? import(`@/views/custom/${s.customCompoment}`) : import(`@/views/service/${s.direction}`),
              meta: { direction: directionName, title: s.subItemName },
            }

            // HSSE Admin
            if (s.url == '/service/hsse/dashboard/monthly_dashboard/admin') {
              let nRoute = {
                path: s.url,
                name: `${s.subItemName}_${t.itemCode}_${s.subItemSn}`, //t.subItemName + '_' + t.itemCode + '_' + t.subItemSn,
                component: () => import('@/views/service/ServiceHsseAdmin'),
                meta: { direction: s.direction, title: s.subItemName },
              }
              tRoute.children.push(nRoute)

              if (!tRoute.redirect) {
                tRoute.redirect = s.url
                tRoute.component = RouterView
              }
              return
            }

            // QC Dashboard Admin
            if (s.url == '/service/quality/quality_dashboard/quality_control_dashboard/admin') {
              let nRoute = {
                path: s.url,
                name: `${s.subItemName}_${t.itemCode}_${s.subItemSn}`, //t.subItemName + '_' + t.itemCode + '_' + t.subItemSn,
                component: () => import('@/views/service/ServiceQCDashboardAdmin'),
                meta: { direction: s.direction, title: s.subItemName },
              }
              tRoute.children.push(nRoute)

              if (!tRoute.redirect) {
                tRoute.redirect = s.url
                tRoute.component = RouterView
              }
              return
            }

            if (s.url == '/service/system/account_management/user_service/access_history') {
              let nRoute = {
                path: s.url,
                name: `${s.subItemName}_${t.itemCode}_${s.subItemSn}`, //t.subItemName + '_' + t.itemCode + '_' + t.subItemSn,
                component: () => import('@/views/system/SysenvAccessHistory'),
                meta: { direction: s.direction, title: s.subItemName },
              }
              tRoute.children.push(nRoute)

              if (!tRoute.redirect) {
                tRoute.redirect = s.url
                tRoute.component = RouterView
              }
              return
            }
            if (s.url == '/service/system/account_management/user_service/account_management') {
              let nRoute = {
                path: s.url,
                name: `${s.subItemName}_${t.itemCode}_${s.subItemSn}`, //t.subItemName + '_' + t.itemCode + '_' + t.subItemSn,
                component: () => import('@/views/system/SvcAccessUserAccount'),
                meta: { direction: s.direction, title: s.subItemName },
              }
              tRoute.children.push(nRoute)
              
              if (!tRoute.redirect) {
                tRoute.redirect = s.url
                tRoute.component = RouterView
              }
              return
            }
            if (s.direction) {
              // init parent's children at the first child met
              // which is not in unavailable
              // if(s.subItemStatus == 'SERVICE' && tRoute.children.length === 0) {
              if (s.subItemStatus == 'SERVICE' && !tRoute.redirect) {
                tRoute.redirect = s.url
                // change parent component none to pass the destination
                tRoute.component = RouterView
              }
              // add direction activated route
              tRoute.children.push(sRoute)
            }
          })
        }

        if (t.itemStatus == 'SERVICE' && (tRoute.children.length > 0 || t.direction)) {
          if (!gRoute.redirect) gRoute.redirect = t.url
          // add direction activated route
          gRoute.children.push(tRoute)
        }
      })
      // init parent's children at the first children met
      // if(!pRoute.children.length === 0 && g.children.length > 0) pRoute.redirect = `${rPath}${pPath}${gPath}`
      if (!pRoute.redirect && g.children.length > 0) pRoute.redirect = g.url
      // add direction activated route
      pRoute.children.push(gRoute)
    })

    rRoutes.push(pRoute)
  })
  callback(rRoutes)
}


